<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" />

                <div class="page-block">
                    <technical-management-tabs :step="1" :domain="domain" :service="firstServiceForDomain" />

                    <div v-if="dnsZoneNotFound" class="page-block__item-wrapper">
                        <p>{{ dnsZoneNotFound }}</p>
                        <button @click="create" class="btn btn--ghost">{{ trans('page.dns.create-zone') }}</button>
                    </div>
                    <dns-overview
                        v-if="dnsZoneNotFound === false"
                        :records="records"
                        :domain="domain"
                        :updating="updatingStatus"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apiMixin } from 'relapp-api';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from 'relapp-event';
import { DnsOverview, DnsApi } from 'relapp-dns';
import { HeaderPartial, serviceMixin, servicesPageMixin } from 'relapp-technical-management';

export default {
    components: {
        DnsOverview,
        HeaderPartial
    },
    mixins: [apiMixin, pageLoadingStatusMixin, serviceMixin, servicesPageMixin],
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'dns',
            dnsZoneNotFound: null
        };
    },
    computed: {
        ...mapGetters({
            records: 'dns/records',
            updatingStatus: 'dns/updating'
        })
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.dns.overview', { domain: this.domain })
        };
    },
    /**
     * Called after the instance has been mounted.
     *
     * @todo only get the dns if you have a dns subscription
     */
    mounted() {
        this.getDns();
    },
    methods: {
        ...mapActions({
            setDNSDomain: 'dns/setDomain'
        }),
        /**
         * Get the DNS records.
         */
        getDns() {
            this.setDNSDomain(this.domain);
            DnsApi.get(this.routeParams, true)
                .then(() => {
                    let res = this.finishLoading();

                    this.dnsZoneNotFound = false;

                    return res;
                })
                .catch(error => {
                    if (error.data && error.data.message) {
                        this.dnsZoneNotFound = error.data.message;
                    } else {
                        this.handleError(error);
                    }
                });
        },
        /**
         * Creates a DNS zone for the domain name.
         */
        create() {
            DnsApi.createZone(this.domain)
                .then(this.getDns)
                .catch(error => {
                    if (error.data && error.data.message) {
                        EventBus.$emit('notification', {
                            type: 'error',
                            message: error.data.message
                        });
                    }
                    this.handleError(error);
                });
        }
    },
    watch: {
        /**
         * Watch if the updating status changed.
         *
         * @param {boolean} status
         */
        updatingStatus(status) {
            if (status) {
                this.startLoading();
            }

            this.finishLoading();
        }
    }
};
</script>
